module.exports = __webpack_public_path__ + "media/images/favicons/android-chrome-192x192-17577b825b507bd7bfc9a8c5c820d27c.png";